import React, { useState, useRef, useEffect } from 'react';

interface DisclaimerTooltipProps {
  children: React.ReactNode;
  className?: string;
}

export const DisclaimerTooltip: React.FC<DisclaimerTooltipProps> = ({ children, className = "inline-block" }) => {
  const [show, setShow] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleTouchStart = () => {
    // Start long-press timer
    timerRef.current = setTimeout(() => {
      setShow(true);
    }, 500); // 500ms for long-press
  };

  const handleTouchEnd = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  const handleClickOutside = (e: MouseEvent) => {
    // If shown via tap/long-press, tap outside to close
    setShow(false);
  };

  useEffect(() => {
    if (show) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [show]);

  return (
    <div 
      className={`relative ${className} cursor-help`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleTouchStart}
      onMouseUp={handleTouchEnd}
    >
      {children}
      {show && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 z-[999] p-3 bg-[#322D29] border border-white/10 rounded-lg text-left pointer-events-none">
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-x-4 border-x-transparent border-t-4 border-t-[#322D29]"></div>
          <p className="text-[10px] font-bold text-white/90 leading-normal uppercase tracking-tight font-dm">
            Algorithmic estimate based on aggregated data. Not a guarantee or professional advice.
          </p>
        </div>
      )}
    </div>
  );
};

export default DisclaimerTooltip;
